import * as React from 'react'
import { TRIPS_HISTORY_DETAILS_TABS } from '../../state/constants/index'
import EntityTabBar from '../ui/entity/EntityTabBar'
import EntityTabBarItem from '../ui/entity/EntityTabBarItem'

interface ITripDetailsTabs {
  activeTab: string
  onTabChange: (tab?: string) => void
}

class TripHistoryDetailsTabs extends React.Component<ITripDetailsTabs> {
  public render() {
    return (
      <EntityTabBar>
        <EntityTabBarItem
          active={this.props.activeTab === TRIPS_HISTORY_DETAILS_TABS.TRIP_DETAILS}
          onClick={this.onTabChange(TRIPS_HISTORY_DETAILS_TABS.TRIP_DETAILS)}
        >
          {TRIPS_HISTORY_DETAILS_TABS.TRIP_DETAILS}
        </EntityTabBarItem>
        <EntityTabBarItem
          active={this.props.activeTab === TRIPS_HISTORY_DETAILS_TABS.AUDIT_LOG}
          onClick={this.onTabChange(TRIPS_HISTORY_DETAILS_TABS.AUDIT_LOG)}
        >
          {TRIPS_HISTORY_DETAILS_TABS.AUDIT_LOG}
        </EntityTabBarItem>
      </EntityTabBar>
    )
  }

  private onTabChange = (tabVal: string) => {
    return () => {
      this.props.onTabChange(tabVal)
    }
  }
}

export default TripHistoryDetailsTabs



// WEBPACK FOOTER //
// ./src/components/trips/TripHistoryDetailsTabs.tsx